import ownerRoutes from './routes'

/* @ngInject */
const run = (
  $transitions,
  toaster,
  storageHandler,
  valueHandler,
  $$owner,
  $$contact,
  $$phone,
  $$email
) => {
  $transitions.onSuccess({
    entering: ownerRoutes.home.path,
  }, async (trans) => {
    try {
      const response = await $$owner.request.getAll()
      $$owner.data.myOwners = response.owners
    } catch (error) {
      toaster.error(error)
    }
  })

  $transitions.onSuccess({
    exiting: ownerRoutes.home.path,
  }, async (trans) => {
    $$owner.data.myOwners = null
  })

  $transitions.onSuccess({
    entering: ownerRoutes.new.path,
  }, (trans) => {
    if (storageHandler.get('savedNewOwner')) {
      $$owner.data.myOwner = storageHandler.get('savedNewOwner')
    } else {
      $$owner.data.myOwner = $$owner.new()
    }
  })

  $transitions.onBefore({
    from: ownerRoutes.new.path,
  }, (trans) => {
    if (!trans.to().redirectTo) {
      storageHandler.save('savedNewOwner', $$owner.data.myOwner)
      $$owner.data.myOwner = null
    }
  })

  $transitions.onSuccess({
    entering: ownerRoutes.details.path,
  }, async (trans) => {
    const ownerId = +$$owner.local.getCurrentId()

    if (valueHandler.isId(ownerId)) {
      try {
        const myOwner = $$owner.request.getById(ownerId)
        const myContacts = $$contact.request.getByOwner(ownerId)

        $$owner.data.myOwner = await myOwner
        $$contact.data.myContacts = await myContacts
      } catch (error) {
        toaster.error(error)
      }
    }
  })

  $transitions.onSuccess({
    exiting: ownerRoutes.details.path,
  }, async (trans) => {
    $$owner.data.myOwner = null
    $$contact.data.myContacts = null
  })

  $transitions.onSuccess({
    entering: ownerRoutes.edit.path,
  }, async (trans) => {
    const ownerId = $$owner.local.getCurrentId()

    try {
      const owner = await $$owner.request.getById(ownerId)
      $$owner.data.myOwner = owner
      $$owner.data.myOwner.oldValue = owner.society

      const contacts = await $$contact.request.getByOwner(owner.id)
      for (let i = 0; i < contacts.length; i++) {
        contacts[i].phones.push($$phone.new())
        contacts[i].emails.push($$email.new())
        contacts[i] = $$contact.format.user(contacts[i])
      }
      $$owner.data.myOwner.contacts = contacts
    } catch (error) {
      toaster.error(error)
    }
  })

  $transitions.onSuccess({
    exiting: ownerRoutes.edit.path,
  }, async (trans) => {
    $$owner.data.myOwner = null
  })
}

export default run



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/owner/owner.run.js